import {
  Box,
  Typography,
} from '@mui/material'
import UseTranslation from '../../hooks/UseTranslation'
import { ReactComponent as BlackLanguage } from '../../images/BlackLanguage.svg'
import { ReactComponent as WhiteLanguage } from '../../images/WhiteLanguage.svg'

const SwitchLanguageButton = ({ login }) => {
  const { toggleGuestAllLanguages, language } = UseTranslation()

  return (
    <Box
      sx={styles.root}
      onClick={toggleGuestAllLanguages}
    >
      <Box sx={styles.toggleIcon}>
        {login ? <BlackLanguage /> : <WhiteLanguage />}
      </Box>
      <Typography sx={styles.textStyle(login)}>
        { language === 'EN' ? 'العربية' : 'English' }
      </Typography>

    </Box>

  )
}
const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '10px',
    '& svg': {
      width: '25px',
      height: '25px',
    },
  },
  textStyle: (login) => ({
    fontSize: '13px !important',
    color: login ? '#000' : '#fff',
    pb: '5px',
  }),
}

export default SwitchLanguageButton
